export function getAll() {
  return [
    {
      value: 0,
      name: "Product",
      text: "商品",
    },
    {
      value: 1,
      name: "Combination",
      text: "組合品",
    },
    {
      value: 2,
      name: "Material",
      text: "原料",
    },
  ];
}
